<template>
  <div v-if="length && hasControls" class="scroller-controls">
    <span
      v-if="hasCounter"
      class="scroller-controls__counter"
      :class="{ 'a-visually-hidden': showDots }"
      aria-live="polite"
      aria-atomic="true"
    >
      <a-label path="slide" />
      {{ currentIndex + 1 }}
      <a-label path="of" />
      <span aria-hidden="true">/</span>
      {{ length }}
    </span>

    <div v-if="length && hasButtonPrevious" class="scroller-controls__buttons">
      <button
        v-if="hasButtonPrevious"
        class="scroller-controls__button scroller-controls__button--prev"
        type="button"
        :aria-controls="ariaControls"
        @click="previous"
      >
        <dpc-icon icon="arrow-left" label-path="showPreviousSlide" />
      </button>
      <button
        v-if="hasButtonNext"
        class="scroller-controls__button scroller-controls__button--next"
        type="button"
        :aria-controls="ariaControls"
        @click="next"
      >
        <dpc-icon icon="arrow-right" label-path="showNextSlide" />
      </button>
    </div>

    <ul v-if="showDots" class="scroller-controls__dots">
      <li
        v-for="(slide, index) in length"
        :key="`scroller-dot-${index}`"
        class="scroller-controls__dot"
      >
        <button
          :aria-controls="ariaControls"
          type="button"
          class="scroller-controls__dot-button"
          :class="{
            'scroller-controls__dot-button--current': index === currentIndex,
          }"
          @click="select(index)"
        >
          <a-label path="jumpToSlide" />
          <span class="a-visually-hidden">{{ index + 1 }}</span>
          <span v-if="index === currentIndex" class="a-visually-hidden">
            (<a-label path="currentSlide" />)
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    length: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    hasButtonNext: {
      type: Boolean,
      default: false,
    },
    hasButtonPrevious: {
      type: Boolean,
      default: false,
    },
    hasDots: {
      type: Boolean,
      default: false,
    },
    hasCounter: {
      type: Boolean,
      default: false,
    },
    ariaControls: {
      type: String,
      required: true,
    },
  },
  emits: ['previous', 'next', 'select'],
  computed: {
    //...mapGetters({
    //  breakpointUp: 'window/breakpointUp',
    //  breakpointDown: 'window/breakpointDown',
    // }),
    /**
     * Returns true when controls exist
     * @callback
     * @returns {boolean}
     */
    hasControls() {
      return this.hasButtonNext || this.hasButtonPrevious || this.hasDots;
    },
    showDots() {
      return (
        this.hasDots &&
        //this.breakpointUp('sm') &&
        this.length > 1
        //this.length <= 3
      );
    },
  },
  methods: {
    previous() {
      this.$emit('previous');
    },
    next() {
      this.$emit('next');
    },
    select(index) {
      this.$emit('select', index);
    },
  },
};
</script>
